// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 157 ? "summer-festival" : chunkId) + "." + {"125":"cf354656","157":"8abbf7a0","833":"0a7eff9b"}[chunkId] + ".chunk.js";
};